import React from 'react'

export default function products() {
    return (
        <h1 className="products">
          PRODUCTS
        </h1>
    )
}
